import { render } from "./SmallScreensFaq.vue?vue&type=template&id=2766496c"
import script from "./SmallScreensFaq.vue?vue&type=script&lang=js"
export * from "./SmallScreensFaq.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__